import RoutingsPage from './RoutingsPage';

const ProductRoutingsPage = () => (
  <RoutingsPage
    routingType="PRODUCT_ROUTING"
    materialType="PRODUCT"
    titleKey="headers.productRoutings"
    entityName="routing-product"
  />
);

export default ProductRoutingsPage;
